// Revisr override of BasicProfileForm.
// Hides the Job Title and Company fields — not required for this product.
// Uses CSS :has() to hide the wrapping div of each input without touching
// the original component's logic or props.

import React from 'react';
import { BasicProfileForm as OriginalBasicProfileForm } from '../../../altzero_plugins/crmfoundation/altzero_main/altzero_plugins/foundation/altzero_base/base/components/profile/BasicProfileForm';


const HIDE_FIELDS_CSS = `
  .revisr-profile-form div:has(> input#job_title),
  .revisr-profile-form div:has(> input#company) {
    display: none !important;
  }
`;

export const BasicProfileForm: typeof OriginalBasicProfileForm = (props) => (
  <div className="revisr-profile-form">
    <style>{HIDE_FIELDS_CSS}</style>
    <OriginalBasicProfileForm {...props} />
  </div>
);
